/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, tree: NonNullable<unknown> }} Purchase_Confirm_With_Time_CrystalsInputs */

const en_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.price} Time Crystals to unlock ${i?.tree}?`)
};

const ar_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هل تريد استخدام ${i?.price} من بلورات الزمن لفتح ${i?.tree}؟`)
};

const de_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} Time Crystals verwenden, um ${i?.tree} freizuschalten?`)
};

const es_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Usar ${i?.price} Cristales de tiempo para desbloquear ${i?.tree}?`)
};

const fr_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utiliser ${i?.price} Cristaux temporels pour débloquer ${i?.tree} ?`)
};

const it_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usare ${i?.price} Cristalli del Tempo per sbloccare ${i?.tree}?`)
};

const ja_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}個の時の結晶を使って${i?.tree}をアンロックしますか？`)
};

const ko_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} 타임 크리스탈을 사용하여 ${i?.tree}을(를) 잠금 해제할까요?`)
};

const pt_br_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.price} Cristais do Tempo para desbloquear ${i?.tree}?`)
};

const ru_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Использовать ${i?.price} кристаллов времени, чтобы разблокировать ${i?.tree}?`)
};

const th_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้ ${i?.price} คริสตัลแห่งกาลเวลาเพื่อปลดล็อก ${i?.tree} ไหม?`)
};

const tr_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tree} kilidini açmak için ${i?.price} Zaman Kristali kullanılsın mı?`)
};

const zh_cn_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} 时光宝石解锁 ${i?.tree}？`)
};

const zh_tw_purchase_confirm_with_time_crystals = /** @type {(inputs: Purchase_Confirm_With_Time_CrystalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} 時光寶石解鎖 ${i?.tree}？`)
};

/**
* | output |
* | --- |
* | "Use {price} Time Crystals to unlock {tree}?" |
*
* @param {Purchase_Confirm_With_Time_CrystalsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const purchase_confirm_with_time_crystals = /** @type {((inputs: Purchase_Confirm_With_Time_CrystalsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Purchase_Confirm_With_Time_CrystalsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_purchase_confirm_with_time_crystals(inputs)
	if (locale === "ar") return ar_purchase_confirm_with_time_crystals(inputs)
	if (locale === "de") return de_purchase_confirm_with_time_crystals(inputs)
	if (locale === "es") return es_purchase_confirm_with_time_crystals(inputs)
	if (locale === "fr") return fr_purchase_confirm_with_time_crystals(inputs)
	if (locale === "it") return it_purchase_confirm_with_time_crystals(inputs)
	if (locale === "ja") return ja_purchase_confirm_with_time_crystals(inputs)
	if (locale === "ko") return ko_purchase_confirm_with_time_crystals(inputs)
	if (locale === "pt_br") return pt_br_purchase_confirm_with_time_crystals(inputs)
	if (locale === "ru") return ru_purchase_confirm_with_time_crystals(inputs)
	if (locale === "th") return th_purchase_confirm_with_time_crystals(inputs)
	if (locale === "tr") return tr_purchase_confirm_with_time_crystals(inputs)
	if (locale === "zh_cn") return zh_cn_purchase_confirm_with_time_crystals(inputs)
	return zh_tw_purchase_confirm_with_time_crystals(inputs)
});